import { Link } from "react-router-dom";
import type { Entry } from "@/mocks/entries";

export function EntryCard({ entry }: { entry: Entry }) {
  return (
    <article
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
      data-product-shop
    >
      <Link to={`/entry/${entry.slug}`} className="block">
        <div className="relative w-full overflow-hidden" style={{ height: "200px" }}>
          <img
            src={entry.cover}
            alt={`${entry.title} — 事件背景与完整记录`}
            title={`${entry.title} — 黑料百科事件词条`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 text-xs font-medium text-primary-600">
            {entry.categoryName}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {entry.publishedAt}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {entry.readMinutes} 分钟
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {entry.views.toLocaleString()}
          </span>
        </div>

        <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/entry/${entry.slug}`} className="transition-colors hover:text-primary-600">
            {entry.title}
          </Link>
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{entry.summary}</p>

        <div className="mt-4 flex flex-wrap gap-2 pt-1">
          {entry.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}

export default EntryCard;